const CHARITY_MISMATCH = 'CHARITY_MISMATCH';

type ApiError = {
  status?: number;
  data?: { errors?: Array<{ code?: string } | null> };
};

const isApiError = (error: unknown): error is ApiError =>
  typeof error === 'object' && error !== null && 'status' in error;

/** True when the API refused the request because the logged-in user belongs to another charity. */
export const isCharityMismatchError = (error: unknown): boolean =>
  isApiError(error) &&
  error.status === 403 &&
  Array.isArray(error.data?.errors) &&
  error.data.errors.some((entry) => entry?.code === CHARITY_MISMATCH);
